import { setMeta, Meta } from '@drapejs/core';
import { imageResize } from '@distancify/drapejs-storyblok';

import useLitium from './useLitium';
import useContext from './useContext';

export default function (middleware?: (meta: Meta) => Meta) {
  const {
     environmentOptions, settings, page, route
  } = useContext();
  const { toLitiumMediaUrl } = useLitium();
  const { siteId } = environmentOptions;

  
  

  setMeta(() => {
    const title = `${page.value.meta?.title || page.value.meta?.metaTitle || page.value.name} | Bellalite`;
    const description = page.value.meta?.description || page.value?.metaDescription || page.value?.description || null;

    const path = page.value?.__sb_full_slug.startsWith(siteId)
      ? page.value?.__sb_full_slug.replace(siteId, '') 
      : page.value?.__sb_full_slug;
    const canonicalUrl = `${route.protocol}//${route.host}${path}`;

    const image = page.value.metaImage
      ? imageResize(page.value.metaImage, { width: 1200, height: 630 })?.filename
      : page.value.imageId
        ? toLitiumMediaUrl(page.value.imageId, {
          maxWidth: 1200,
        })
        : null;

    const result = {
      title,
      lang: 'sv',
      props: {
        'og:title': title,
        'og:description': description,
        description,
        'og:url': canonicalUrl,
        'og:image': image,
        'og:type': 'website',
      },
      links: [
        {
          rel: 'shortcut icon',
          type: 'image/png',
          href: imageResize(settings.value?.favicon, { width: 256, height: 256 })?.filename,
        },
        {
          rel: 'canonical',
          href: canonicalUrl,
        },
      ],
    };

    return middleware ? middleware(result) : result;
  });
}
